import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/$org/users/me')({
    component: UsersMeLayout,
})

function UsersMeLayout() {
    return <Outlet />
}
